import { Container, Stack, Typography } from '@mui/material';
import moment from 'moment';
import { useContext, useState } from 'react';
import BackNavigationButton from '../../../components/common/BackNavigationButton';
import DeferMountWhenVisible from '../../../components/common/DeferMountWhenVisible';
import SextforceMetricsAccountFansCounters from '../../../components/services/sextforce/metrics/account/SextforceMetricsAccountFansCounters';
import SextforceMetricsAccountMonthlySalesGraph from '../../../components/services/sextforce/metrics/account/SextforceMetricsAccountMonthlySalesGraph';
import SextforceMetricsAccountMonthlyUniqueSpenders from '../../../components/services/sextforce/metrics/account/SextforceMetricsAccountMonthlyUniqueSpenders';
import SextforceMetricsAccountSubscriptionsAndEarningsGroupByMonth from '../../../components/services/sextforce/metrics/account/SextforceMetricsAccountSubscriptionsAndEarningsGroupByMonth';
import SextforceMetricsAccountValueStats from '../../../components/services/sextforce/metrics/account/SextforceMetricsAccountValueStats';
import useSubscriber from '../../../hooks/useSubscriber';
import { SettingsContext } from '../../../store/SettingsContext';

const SextforceMetricsAccount = () => {
    const settingsContext = useContext(SettingsContext);
    const { data: subscriber } = useSubscriber();
    // const { dashboardAccount, dashboardAccountLoading } = useDashboardAccount(true);

    const [timezone, setTimezone] = useState<string>(moment.tz.guess());
    const [startDate, setStartDate] = useState<Date>(moment().tz(timezone).subtract(1, 'year').startOf('month').toDate());
    const [endDate, setEndDate] = useState<Date>(moment().tz(timezone).endOf('month').toDate());

    // Set global MomentJS locale
    moment.locale('en-gb');

    // useEffect(() => {
    //     if (!dashboardAccountLoading && dashboardAccount) {
    //         if (dashboardAccount && dashboardAccount.timezone) {
    //             setTimezone(dashboardAccount.timezone);
    //         }
    //     }
    // }, [dashboardAccountLoading, dashboardAccount]);

    return (
        <Container maxWidth={false} sx={{ paddingTop: 4, paddingBottom: 4, backgroundColor: '#e7ebf0', minHeight: '100%' }}>
            <div style={{ paddingBottom: 2 }}>
                <Typography variant="h5">
                    <BackNavigationButton
                        {...(subscriber && { url: `/subscribers/${subscriber._id}/${settingsContext.services.sextforce.homeUrl}` })}
                    />{' '}
                    Metrics for {subscriber?.username}
                </Typography>
            </div>

            <Stack direction="column" spacing={2} sx={{ paddingTop: 2 }}>
                {subscriber && (
                    <DeferMountWhenVisible minHeight={320} rootMargin="400px 0px">
                        <SextforceMetricsAccountValueStats subscriber={subscriber} />
                    </DeferMountWhenVisible>
                )}

                <DeferMountWhenVisible minHeight={360}>
                    <SextforceMetricsAccountSubscriptionsAndEarningsGroupByMonth />
                </DeferMountWhenVisible>

                <DeferMountWhenVisible minHeight={320}>
                    <SextforceMetricsAccountMonthlySalesGraph startDate={startDate} endDate={endDate} timezone={timezone} />
                </DeferMountWhenVisible>

                <DeferMountWhenVisible minHeight={280}>
                    <SextforceMetricsAccountMonthlyUniqueSpenders startDate={startDate} endDate={endDate} timezone={timezone} />
                </DeferMountWhenVisible>

                <DeferMountWhenVisible minHeight={400}>
                    <SextforceMetricsAccountFansCounters startDate={startDate} endDate={endDate} timezone={timezone} />
                </DeferMountWhenVisible>
            </Stack>
        </Container>
    );
};

export default SextforceMetricsAccount;
